import React from 'react';
import Modal from './Modal';
import './TableModal.css';

/**
 * Modal that renders a pipe-table's structured data as a styled HTML table.
 *
 * @param {{ isOpen: boolean, onClose: () => void, headers: string[], rows: string[][], caption?: string }} props
 */
const TableModal = ({ isOpen, onClose, headers = [], rows = [], caption = '' }) => {
  if (!isOpen) return null;

  const title = caption || 'Table';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="large" showCloseButton>
      <div className="table-modal-scroll">
        <table className="table-modal-table">
          {headers.length > 0 && (
            <thead>
              <tr>
                {headers.map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && (
          <p className="table-modal-empty">No data rows found.</p>
        )}
      </div>
    </Modal>
  );
};

export default TableModal;
